import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { CalendarIcon, ChevronDownIcon, InfoIcon } from 'lucide-react';
export function Hero() {
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: containerRef,
    offset: ['start start', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['0%', '50%']);
  const opacity = useTransform(scrollYProgress, [0, 1], [1, 0]);
  return <div ref={containerRef} className="relative w-full h-screen overflow-hidden bg-[#132c53]" data-id="element-153">
      {/* Background Image */}
      <motion.div className="absolute inset-0" style={{
      y
    }} data-id="element-154">
        <div className="absolute inset-0 bg-gradient-to-br from-[#132c53] via-[#1a3a6b] to-[#132c53]" data-id="element-155" />
        <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{
        backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/dPNkQNQfNcZPQpyW1TES5p/cuza_voda_poza_1.png')"
      }} data-id="element-156" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#132c53] via-transparent to-[#132c53]/50" data-id="element-157" />
      </motion.div>
      {/* Content */}
      <motion.div className="relative z-10 h-full flex flex-col" style={{
      opacity
    }} data-id="element-158">
        {/* Header with Logo */}
        <motion.div className="px-6 py-6 md:px-12 lg:px-16" initial={{
        y: -50,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} transition={{
        duration: 0.8
      }} data-id="element-159">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qg3u3nCKM719Xao3tc39be/logo_transparent_clc_alb.png" alt="cautlocuinta.ro" className="h-24 md:h-32" data-id="element-160" />
        </motion.div>
        {/* Main Content */}
        <div className="flex-1 flex items-center justify-center px-6 md:px-12 lg:px-16" data-id="element-161">
          <div className="max-w-5xl w-full text-center" data-id="element-162">
            {/* Exclusivity Badge */}
            <motion.div className="inline-block mb-6" initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} data-id="element-163">
              <span className="px-6 py-2 bg-[#357beb] text-white text-sm font-bold rounded-full shadow-lg" data-id="element-164">
                Exclusivitate cautlocuinta.ro
              </span>
            </motion.div>
            {/* Main Title */}
            <motion.h1 className="text-4xl md:text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight" initial={{
            y: 50,
            opacity: 0
          }} animate={{
            y: 0,
            opacity: 1
          }} transition={{
            duration: 0.8,
            delay: 0.4
          }} data-id="element-165">
              Oportunitate de investiție{' '}
              <span className="text-[#357beb]" data-id="element-166">exclusivă</span> în centrul
              Bucureștiului
            </motion.h1>
            {/* Subtitle */}
            <motion.p className="text-xl md:text-2xl text-gray-200 mb-12 max-w-4xl mx-auto" initial={{
            y: 50,
            opacity: 0
          }} animate={{
            y: 0,
            opacity: 1
          }} transition={{
            duration: 0.8,
            delay: 0.6
          }} data-id="element-167">
              Imobil multifuncțional, complet funcțional, cu randament ridicat
              și potențial de reconversie rezidențială.
            </motion.p>
            {/* CTA Buttons */}
            <motion.div className="flex flex-col sm:flex-row gap-4 justify-center items-center" initial={{
            y: 50,
            opacity: 0
          }} animate={{
            y: 0,
            opacity: 1
          }} transition={{
            duration: 0.8,
            delay: 0.8
          }} data-id="element-168">
              <a href="#overview" className="group w-full sm:w-auto px-10 py-5 bg-white hover:bg-gray-100 text-[#132c53] font-bold rounded-lg flex items-center justify-center gap-3 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105" data-id="element-169">
                <InfoIcon className="w-6 h-6 group-hover:scale-110 transition-transform" data-id="element-170" />
                Vezi detalii
              </a>
              <a href="#contact" className="group w-full sm:w-auto px-10 py-5 bg-[#357beb] hover:bg-[#2868d9] text-white font-bold rounded-lg flex items-center justify-center gap-3 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105" data-id="element-171">
                <CalendarIcon className="w-6 h-6 group-hover:scale-110 transition-transform" data-id="element-172" />
                Solicită vizionare
              </a>
            </motion.div>
          </div>
        </div>
        {/* Scroll Indicator */}
        <motion.div className="pb-8 flex justify-center" animate={{
        y: [0, 10, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} data-id="element-173">
          <ChevronDownIcon className="w-8 h-8 text-[#357beb]" data-id="element-174" />
        </motion.div>
      </motion.div>
    </div>;
}